module.exports = __webpack_public_path__ + "0d478df2e62fe630db30d74b2693f0ce.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-header/sp-breadcrumbs/sp-breadcrumbs.html
// module id = 1122
// module chunks = 0